window.$ = require("jquery");
window.jQuery = require("jquery");

require('datatables.net');

require("./app/blocks/main-nav");
require("./app/blocks/mail-list");

require("./app/blocks/overlay-terms-conditions");

require("./app/pages/race-subscribe-wizard");
require("./app/pages/circuit-subscribe-wizard");

require("./race-manager/race-order.js")

$(document).ready( () => {

	$(".print-icon").on("click tap", () => {
		window.print();
	});

	// Initialize DataTable only if table exists and is not already initialized
	var team_members_table = null;
	if ($('#team-members').length > 0) {
		// Check if already initialized
		if ($.fn.DataTable.isDataTable('#team-members')) {
			// Already initialized, get existing instance
			team_members_table = $('#team-members').DataTable();
		} else {
			// Initialize new DataTable
			team_members_table = $('#team-members').DataTable({
				paging: false,
				ordering: false,
				info: false,
				dom: 't'
			});
		}
	}

	/*
	* Search
	*/
	$('#search_team_member').on('input', function() {
		var searchValue = $(this).val();

		// Show table when user starts typing, hide when empty
		if (searchValue.length > 0) {
			$('.team-members-wrapper').fadeIn(200);
		} else {
			$('.team-members-wrapper').fadeOut(200);
		}

		// Perform search only if DataTable exists
		if (team_members_table) {
			team_members_table.search(searchValue).draw();
		}
	});

	/*
	 * Get team members data buttons
	 */
	document.querySelectorAll('.team-members tbody tr').forEach( ($row) => {
		$row.addEventListener( 'click', (e) => {
				e.preventDefault()
				document.location = '?autofill-contact-id=' + $row.dataset.contact_id
			})
	})

});
